var _mask, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTesla(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "tesla_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 10,
    width: 22,
    height: 22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.058 10.42H30.63v20.83H9.058V10.42z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tesla_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.224 14.743c-1.286-.492-2.276-1.18-3.166-2.358 1.385-.492 2.671-.983 3.958-1.278 1.385-.294 2.672-.491 4.057-.688.198 0 .396.099.495.197.693.786 1.287 1.572 1.98 2.358.098.098.197.295.395.393.792-.884 1.484-1.769 2.276-2.653 0-.098.198-.295.396-.295 2.672.197 5.344.787 7.818 1.867.099 0 .099.099.198.099-.297.687-1.683 1.866-3.068 2.358-.198-1.278-1.188-1.474-2.276-1.67-.594-.099-1.188-.099-1.682-.099-.297 0-.396.098-.396.393-.792 4.716-1.683 9.433-2.573 14.149-.198 1.277-.495 2.456-.693 3.734-.198-.983-.396-1.965-.495-2.948l-2.672-14.738c-.198-.393-.296-.59-.791-.59-.693.098-1.386.098-1.98.197-.89.098-1.682.49-1.78 1.572z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 10.41c7.917-3.046 15.833-3.046 23.75 0-.198.393-.396.785-.594 1.08-.099.098-.297.098-.396.098A33.63 33.63 0 0024.75 9.82c-2.672-.393-5.443-.491-8.213-.197-2.573.295-5.047.983-7.422 1.966-.198.098-.396.098-.495-.099-.1-.393-.297-.688-.495-1.08z"
  })));
}
export default SvgTesla;